import EventUtils from '@/common/utils/EventUtils';
let handlers = [];
export default {
  bind(dom) {
    this._target = dom;
    this._listener = function(e) {
      let target = e.target || e.srcElement;
      if (target.scrollingElement) {
        target = target.scrollingElement;
      } else if (target.documentElement) {
        // for IE
        target = target.documentElement;
      }
      let scrollTop = target.scrollTop;
      let scrollHeight = target.scrollHeight;
      let scrollLeft = target.scrollLeft;
      let param = {
        scrollLeft,
        scrollTop,
        scrollHeight,
        innerHeight: window.innerHeight
      };
      for (let i = 0; i < handlers.length; i++) {
        handlers[i](param);
      };
    };
    EventUtils.attach('scroll', this._listener, dom);
  },
  unbind() {
    EventUtils.detach('scroll', this._listener, this._target);
  },
  register(handler) {
    handlers.push(handler);
  },
  degister(handler) {
    for (let i = 0; i < handlers.length; i++) {
      if (handler === handlers[i]) {
        handlers.splice(i, 1);
        break;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/open/common/ScrollManager.js